export default __webpack_public_path__ + "static/media/List-documentation.60691cae.md";